import React from 'react';

const ALLOWED_PATH_PREFIXES = ['/ll/', '/project-view', '/pm-view', '/super-view', '/custom-settings'];

function getSavedRedirect() {
    try {
        const saved = sessionStorage.getItem('postLoginRedirect');
        sessionStorage.removeItem('postLoginRedirect');
        if (!saved) return null;
        if (!saved.startsWith('/')) return null;
        if (!ALLOWED_PATH_PREFIXES.some(prefix => saved.startsWith(prefix))) return null;
        return saved;
    } catch {
        return null;
    }
}

function getCanonicalOrigin() {
    const { hostname, origin } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return origin;
    if (hostname.includes('lessons')) return 'https://lessons.arcomurray.com';
    return 'https://roster.arcomurray.com';
}

function getDefaultPath() {
    if (window.location.hostname.includes('lessons')) {
        return '/ll/view';
    }
    return '/project-view';
}

export default function AuthCallback(props) {
    React.useEffect(() => {
        const path = getSavedRedirect() || getDefaultPath();
        window.location.href = `${getCanonicalOrigin()}${path}`;
    }, []);
    return (
        <div>
            Redirecting...
        </div>
    );
}
